const BASE_API_URL = process.env.REACT_APP_API_URL || 'http://0.0.0.0:8000';

export {
    BASE_API_URL
}